<template>
  <div v-if="large && !sharePreview" class="app-container" uk-height-viewport="expand: true">
      <error-full-page :errorHeading="errorInfo.errorHeading" :errorDescription="errorInfo.errorDescription"
                       :errorCode="errorInfo.errorCode"
                       :showSearch="errorInfo.showSearch"></error-full-page>
  </div>
  <div v-else-if="sharePreview">
    <error-sharelink :errorHeading="errorInfo.errorHeading" :errorDescription="errorInfo.errorDescription"
                     :errorCode="errorInfo.errorCode"
                     :showSearch="errorInfo.showSearch"></error-sharelink>
  </div>
  <div v-else-if="!sharePreview && !large" class="uk-flex uk-flex-center">
    <error-card :errorHeading="errorInfo.errorHeading" :errorDescription="errorInfo.errorDescription"
                :errorCode="errorInfo.errorCode"
                :showSearch="errorInfo.showSearch"></error-card>
  </div>
</template>
<script>
  import ErrorCard from './error-card'
  import ErrorFullPage from './error-fullpage'
  import ErrorSharelink from './error-sharelink'
  import errorService from './../../services/error-info-service'

  export default {
    components: {
      ErrorSharelink,
      ErrorCard,
      ErrorFullPage
    },
    name: 'content-errors',
    props: ['error', 'large', 'sharePreview'],
    data() {
      return {
        errorInfo: {}
      }
    },
    methods: {
      getErrorInfo() {
        let type = this.sharePreview ? 'sharePreview' : ''
        let errors = this.$t('error')
        this.errorInfo = errorService.errorInfo(type, this.error, errors)
      }
    },
    mounted() {
      setTimeout(() => {
        this.getErrorInfo()
      }, 250)
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../styles/breakpoints';
  .app-container {
    padding-top: 86px;
  }

  @media screen and (max-width: $breakpoint-medium) {
    .app-container {
      width: 100%;
      padding-top: 115px;
    }
  }
</style>
